import { useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../context/ThemeContext";
import { t } from "i18next";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "../Pages/casino/ListHome";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { startCase } from "lodash";

const MenuWeb = () => {
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const toggleTheme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.toggleTheme;
  });
  const location = useLocation();
  const [show, setShow] = useState("");
  const navigate = useNavigate();
  const handel = (e) => {
    setSidebarModal(true);
    if (show == e) {
      setShow("");
    } else {
      setShow(e);
    }
  };

  useEffect(() => {
    setShow("");
  }, [location]);

  const getImageUrl = (url) => {
    return url;
  };

  const SingleUl = ({ data, item }) => {
    return (
      <app-collapse-alpha
        _ngcontent-serverapp-c568765798
        _nghost-serverapp-c2435129876
        className="ng-tns-c2435129876-8 ng-tns-c568765798-3 ng-star-inserted"
      >
        <div
          _ngcontent-serverapp-c2435129876
          className="collapse-alpha ng-tns-c2435129876-8 ng-trigger ng-trigger-collapse"
        >
          <div
            _ngcontent-serverapp-c568765798
            className="nav-item__body nav-item-body ng-tns-c2435129876-8"
          >
            <ul
              _ngcontent-serverapp-c568765798
              className="nav-item-body__ul ng-tns-c568765798-3"
              ot-tag="menu_null_F"
            >
              <li
                onClick={() => navigate(`/casino?type=${item}&provider=all`)}
                _ngcontent-serverapp-c568765798
                className="nav-item-body__li nav-item nav-item--descend nav-item--router ng-tns-c568765798-3 ng-star-inserted"
                web-category-type="VENDOR"
              >
                <div
                  _ngcontent-serverapp-c568765798
                  className="nav-item__icon ng-tns-c568765798-3"
                  style={{
                    "background-image": `url(${getImageUrl(
                      "/assets/Icon/icon-all-provider.svg",
                    )})`,
                  }}
                />
                <p
                  _ngcontent-serverapp-c568765798
                  className="nav-item__text ng-tns-c568765798-3"
                >
                  ALL PROVIDER
                </p>
              </li>

              {data?.map((res) => {
                return (
                  <li
                    _ngcontent-serverapp-c568765798
                    className="nav-item-body__li nav-item nav-item--descend nav-item--router ng-tns-c568765798-3 ng-star-inserted"
                    web-category-type="VENDOR"
                    onClick={() =>
                      navigate(`/casino?type=${item}&provider=${res?.name}`)
                    }
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="nav-item__icon ng-tns-c568765798-3"
                      style={{
                        "background-image": `url(${res?.image})`,
                      }}
                    />
                    <p
                      _ngcontent-serverapp-c568765798
                      className="nav-item__text ng-tns-c568765798-3"
                    >
                      {res?.name}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </app-collapse-alpha>
    );
  };
  return (
    <app-left-menu
      _ngcontent-serverapp-c1218069548
      className="layout-desktop__menu ng-tns-c1218069548-2 ng-tns-c568765798-3 ng-star-inserted"
      _nghost-serverapp-c568765798
    >
      <div
        style={{ height: "100dvh" }}
        _ngcontent-serverapp-c568765798
        id="left-menu"
        className={`left-menu ng-tns-c568765798-3 ${
          !sidebarModal ? "left-menu--mini" : ""
        }   ng-star-inserted`}
      >
        <div
          _ngcontent-serverapp-c568765798
          className="left-menu__head ng-tns-c568765798-3 left-menu__head--auto"
        >
          <div
            onClick={() => setSidebarModal(!sidebarModal)}
            _ngcontent-serverapp-c568765798
            className={`left-menu__head-arrow head-arrow ng-tns-c568765798-3 ${
              sidebarModal ? "head-arrow--active" : ""
            }`}
          >
            <div
              _ngcontent-serverapp-c568765798
              className="head-arrow__icon ng-tns-c568765798-3"
              style={{
                "mask-image": 'url("/assets/Other/accordion-arrow.svg")',
              }}
            />
          </div>
          <div
            _ngcontent-serverapp-c568765798
            className="left-menu__head-item head-item ng-tns-c568765798-3 ng-star-inserted"
            tabIndex={0}
            ot-tag="tab_Exchange_F"
            style={{}}
          >
            {/* <div
              _ngcontent-serverapp-c568765798
              className="head-item__icon ng-tns-c568765798-3"
              style={{
                "background-image": `url(${getImageUrl(
                  "/assets/Icon/icon-e2exchange.svg",
                )})`,
              }}
            />*/}
            <p
              _ngcontent-serverapp-c568765798
              className="head-item__text ng-tns-c568765798-3"
            >
             Home
            </p> 
          </div>
        </div>
        <div
          _ngcontent-serverapp-c568765798
          className="left-menu__content left-menu-content ng-tns-c568765798-3"
        >
          <div
            _ngcontent-serverapp-c568765798
            className="left-menu-content__home ng-tns-c568765798-3"
            tabIndex={0}
          >
            <div
              _ngcontent-serverapp-c568765798
              className={`nav-item ng-tns-c568765798-3 ${
                !sidebarModal ? "nav-item--mini" : ""
              } `}
            >
              <div
                _ngcontent-serverapp-c568765798
                className="nav-item__head ng-tns-c568765798-3"
              >
                <span
                  _ngcontent-serverapp-c568765798
                  className="nav-item__icon ng-tns-c568765798-3"
                  style={{
                    backgroundImage: `url(${getImageUrl(
                      "/assets/NewIcon/icon-home.png",
                    )})`,
                  }}
                />
                <p
                  _ngcontent-serverapp-c568765798
                  className="nav-item__text ng-tns-c568765798-3"
                >
                  {t("Home")}
                </p>
              </div>
            </div>
          </div>
          {/* <div
            _ngcontent-serverapp-c568765798
            className="left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 ng-star-inserted"
          >
            <div
              _ngcontent-serverapp-c568765798
              className={`nav-item ng-tns-c568765798-3 ${
                !sidebarModal ? "nav-item--mini" : ""
              } `}
            >
              <div
                _ngcontent-serverapp-c568765798
                className="nav-item__head ng-tns-c568765798-3"
              >
                <span
                  _ngcontent-serverapp-c568765798
                  className="nav-item__icon ng-tns-c568765798-3"
                  style={{
                    "background-image": `url(${getImageUrl(
                      "/assets/Icon/icon-e2exchange.svg",
                    )})`,
                  }}
                />
                <p
                  _ngcontent-serverapp-c568765798
                  className="nav-item__text ng-tns-c568765798-3"
                >
                  9 WICKETS
                </p>
              </div>
            </div>
          </div> */}

          <cdk-accordion
            _ngcontent-serverapp-c568765798
            className="left-menu-content__accordion ng-tns-c568765798-3"
          >
            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 ${
                  show == "sports" ? "" : "nav-item--collapsed"
                }  ${!sidebarModal ? "nav-item--mini" : ""} `}
                data-category="sport"
              >
                <div
                  onClick={() => handel("sports")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>

                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                      "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-sport.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {" "}
                    {t("Sports")}
                  </p>
                </div>

                {show == "sports" && (
                  <app-collapse-alpha
                    _ngcontent-serverapp-c568765798
                    _nghost-serverapp-c2435129876
                    className="ng-tns-c2435129876-6 ng-tns-c568765798-3 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c2435129876
                      className="collapse-alpha ng-tns-c2435129876-6 ng-trigger ng-trigger-collapse"
                    >
                      <div
                        _ngcontent-serverapp-c568765798
                        className="nav-item__body nav-item-body ng-tns-c2435129876-6"
                      >
                        <ul
                          _ngcontent-serverapp-c568765798
                          className="nav-item-body__ul ng-tns-c568765798-3"
                          ot-tag="menu_Sport_F"
                        >
                          {/* {" "}
                          <li
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/sports");
                            }}
                            _ngcontent-serverapp-c568765798
                            className="nav-item-body__li nav-item nav-item--descend nav-item--router ng-tns-c568765798-3 ng-star-inserted"
                            tabIndex={0}
                            style={{}}
                          >
                            <div
                              _ngcontent-serverapp-c568765798
                              className="nav-item__icon ng-tns-c568765798-3"
                              style={{
                                "background-image": `url(${getImageUrl(
                                  "/assets/Icon/icon-e2exchange.svg",
                                )})`,
                              }}
                            />

                            <p
                              _ngcontent-serverapp-c568765798
                              className="nav-item__text ng-tns-c568765798-3"
                            >
                              9 WICKETS
                            </p>
                          </li> */}
                          <li
                            onClick={(e) => {
                              e.preventDefault();
                              window.location.href = "/sports-velki";
                            }}
                            _ngcontent-serverapp-c568765798
                            className="nav-item-body__li nav-item nav-item--descend nav-item--router ng-tns-c568765798-3 ng-star-inserted"
                            tabIndex={0}
                            style={{}}
                          >
                            <div
                              _ngcontent-serverapp-c568765798
                              className="nav-item__icon ng-tns-c568765798-3"
                              style={{
                                "background-image": `url(${getImageUrl(
                                  "/assets/Icon/icon-cricket.svg",
                                )})`,
                              }}
                            />

                            <p
                              _ngcontent-serverapp-c568765798
                              className="nav-item__text ng-tns-c568765798-3"
                            >
                              Velkie
                            </p>
                          </li>
                          <li
                            onClick={(e) => {
                              e.preventDefault();
                              window.location.href = "/sports-sky";
                            }}
                            _ngcontent-serverapp-c568765798
                            className="nav-item-body__li nav-item nav-item--descend nav-item--router ng-tns-c568765798-3 ng-star-inserted"
                            imageclass="exchange"
                            style={{}}
                          >
                            <div
                              _ngcontent-serverapp-c568765798
                              className="nav-item__icon ng-tns-c568765798-3 item-sport exchange ng-star-inserted"
                              style={{
                                "background-image": `url(${getImageUrl(
                                  "/assets/Icon/icon-exchange.svg",
                                )})`,
                              }}
                            />

                            <p
                              _ngcontent-serverapp-c568765798
                              className="nav-item__text ng-tns-c568765798-3"
                            >
                              SKYExchange
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </app-collapse-alpha>
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3  ${
                  show == "casino" ? "" : "nav-item--collapsed"
                } ${!sidebarModal ? "nav-item--mini" : ""} `}
                data-category="CASINO"
              >
                <div
                  onClick={() => handel("casino")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                      "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-casino.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Casino")}
                  </p>
                </div>
                {show == "casino" && (
                  <SingleUl item={"casino"} data={filtercasion} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 ${
                  show == "slots" ? "" : "nav-item--collapsed"
                } ${!sidebarModal ? "nav-item--mini" : ""} `}
                data-category="SLOTS"
              >
                <div
                  onClick={() => handel("slots")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-slot.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Slots")}
                  </p>
                </div>
                {show == "slots" && (
                  <SingleUl item={"slots"} data={filterslot} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } ${show == "table" ? "" : "nav-item--collapsed"}`}
                data-category="TABLE"
              >
                <div
                  onClick={() => handel("table")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-table.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Table")}
                  </p>
                </div>

                {show == "table" && (
                  <SingleUl item={"table"} data={filtertable} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } ${show == "crash" ? "" : "nav-item--collapsed"}`}
                data-category="CRASH"
              >
                <div
                  onClick={() => handel("crash")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-crash.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Crash")}
                  </p>
                </div>

                {show == "crash" && (
                  <SingleUl item={"crash"} data={filtercrash} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } ${show == "fishing" ? "" : "nav-item--collapsed"}`}
                data-category="FISHING"
              >
                <div
                  onClick={() => handel("fishing")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-fish.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Fishing")}
                  </p>
                </div>

                {show == "fishing" && (
                  <SingleUl item={"fishing"} data={filterfishing} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } ${show == "arcade" ? "" : "nav-item--collapsed"}`}
                data-category="ARCADE"
              >
                <div
                  onClick={() => handel("arcade")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-arcade.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Arcade")}
                  </p>
                </div>

                {show == "arcade" && (
                  <SingleUl item={"arcade"} data={filterarcade} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } ${show == "lottery" ? "" : "nav-item--collapsed"}`}
                data-category="LOTTERY"
              >
                <div
                  onClick={() => handel("lottery")}
                  _ngcontent-serverapp-c568765798
                  className="nav-item__head ng-tns-c568765798-3 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c568765798
                    className="nav-item__collapse-arrow collapse-arrow ng-tns-c568765798-3"
                  >
                    <div
                      _ngcontent-serverapp-c568765798
                      className="collapse-arrow__icon ng-tns-c568765798-3"
                      style={{
                        "mask-image":
                          'url("/assets/Other/accordion-arrow.svg")',
                      }}
                    />
                  </div>
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                       "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-lottery.webp",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("Lotto")}
                  </p>
                </div>

                {show == "lottery" && (
                  <SingleUl item={"lottery"} data={filterlotto} />
                )}
              </div>
            </cdk-accordion-item>

            <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } `}
                data-category="promotions"
              >
                <Link
                  _ngcontent-serverapp-c568765798
                  className="nav-item__link ng-tns-c568765798-3 ng-star-inserted"
                  to="/promotions"
                  state={{ background: location }}
                >
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                      "background-image": `url(${getImageUrl(
                        "/assets/NewIcon/icon-promotion.png",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("PROMOITIONS")}
                  </p>
                </Link>
              </div>
            </cdk-accordion-item>

            {/* <cdk-accordion-item
              _ngcontent-serverapp-c568765798
              className="ng-tns-c568765798-3 ng-star-inserted"
              accordion-template="true"
            >
              <div
                _ngcontent-serverapp-c568765798
                className={`left-menu-content__item left-menu-content__item--grouped nav-item ng-tns-c568765798-3 nav-item--collapsed ${
                  !sidebarModal ? "nav-item--mini" : ""
                } `}
                data-category="vip"
              >
                <Link
                  _ngcontent-serverapp-c568765798
                  className="nav-item__link ng-tns-c568765798-3 ng-star-inserted"
                  to="/vip"
                  state={{ background: location }}
                >
                  <span
                    _ngcontent-serverapp-c568765798
                    className="nav-item__icon ng-tns-c568765798-3 ng-star-inserted"
                    style={{
                      "background-image": `url(${getImageUrl(
                        "/assets/Icon/icon-vip.svg",
                      )})`,
                    }}
                  />

                  <p
                    _ngcontent-serverapp-c568765798
                    className="nav-item__text ng-tns-c568765798-3 ng-star-inserted"
                  >
                    {t("MyVIP")}
                  </p>
                </Link>
              </div>
            </cdk-accordion-item> */}
          </cdk-accordion>
        </div>
      </div>
    </app-left-menu>
  );
};

export default MenuWeb;
